<template>

  <div id="HearingPureToneTestSpeaker">

      <div class="HearingTest-test--part" >
        <div class="info-help" v-show="!started" >
          <div class="HearingTest-test--part" >

            <div class="HearingTest-test--title">تست تون خالص</div>
            <div class="HearingTest-test--text">این تست آهسته ترین صداهایی که یک شخص در فرکانس های مختلف میتواند بشنود را مشخص میکند.</div>
            <button class="HearingTest-test--button" style="display: block; float: none; margin: 0px auto;"  @click="startTest()"><span>شروع تست</span> &gt;</button>
          </div>
        </div>
        <div v-show="started">

          <div class="HearingTest-test--title "><icon name="volume-up"></icon>دوطرف </div>

          <div class="HearingTest-test--text">وقتی صدا را شنیدید بر روی <strong>بله</strong> کلیک کنید</div>

          <div class="HearingTest-test--calibrationContainer">
            <div class="HearingTest-test--volumeContainer"></div>
            <div class="HearingTest-test--spinnerBubbles">
              <div class="HearingTest-test--playButtonContainer">

                <div data-frequency="ptFrequency1" class="HearingTest-test--frequency">
                  <span v-show="loadingTone" ><icon name="spinner" pulse></icon></span>
                  <span  v-show="!loadingTone">{{currTone}}<br><span style="font-size: 22px;">HZ</span></span>
                </div>
              </div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 31px; margin-top: 92px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 53px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 11px; margin-top: -26px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 72px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: -4px; margin-top: -34px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 87px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: -11px; margin-top: -36px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 94px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: -8px; margin-top: -37px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 93px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 1px; margin-top: -36px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 83px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 18px; margin-top: -30px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 65px; margin-top: -17px;"></div>
              <div class="HearingTest-test--spinnerBubble" style="margin-right: 41px; margin-top: -23px;"></div>
            </div>

            <div class="HearingTest-test--volumeContainer"></div>
          </div>
          <div class="clearfix"></div>
          <div class="HearingTest-test--toneButton ng-binding" v-show="!nextBtn" @click="nextTest()">بله</div>
          <div class="HearingTest-test--toneButton red ng-binding" v-show="nextBtn" @click="startTest()">بعدی!</div>
        </div>
      </div>
      <div class="clearfix"></div>
  </div>

</template>

<script>

export default {
    name: 'HearingPureToneTestSpeaker',
    props: ['starting'],
    components: {
    },
  created() {

      this.curAudio = this.tones[500];

  },
  data () {

    return {
        started : false,
        curAudio: null,
        tones:{
            500: new Audio(window.pure_tone.tone500)  ,
            1000: new Audio(window.pure_tone.tone1000)  ,
            2000: new Audio(window.pure_tone.tone2000)  ,
            4000: new Audio(window.pure_tone.tone4000)  ,
        },
        currTone:500,
        curCounterTone:0,
        answers : [],
        intervals: null,
        passed: 1,
        timeCounter : 0,
        loadingTone: true,
        test: 0,
        nextBtn: false,
        answered: false,

    }
  },
    methods:{
        startTest(){

            let self = this;

            this.started = true;

            clearInterval(this.intervals);
            this.curAudio.volume = 0;
            this.curAudio.pause();

            this.curAudio.currentTime = 0;

            this.timeCounter = 0;

            this.intervals = setInterval(function() {
                //let volPlus = ((self.curCounterTone <= 1) ? window.calibrationAnswers.data.second :window.calibrationAnswers.data.first)/ 100;
                let volPlus = (window.calibrationAnswers.data.first - window.calibrationAnswers.data.second)/ 100;

                let volume = volPlus + ((self.curCounterTone > 1 ? (self.curCounterTone -1) : 0 ) / 20);

                volume = volume > 1 ? 1 : volume;
                self.curAudio.volume = volume;
                self.curAudio.play();
                //console.log(volPlus,window.calibrationAnswers.data.first , ((self.curCounterTone -1)),volume);

                self.test += 1;

                if (self.curAudio.readyState <= 2)
                    return false;

                self.checkAudioForPlay();


            }, 100)

        },
        checkAudioForPlay(){
            this.loadingTone = false;

            this.nextBtn = false;
            // if timeCounter is 0 so play this audio
            if(this.timeCounter === 0) {
                this.playAudio();
            }

            // plus timeCounter
            this.timeCounter += 100;

            // if 3 seconds is done. so next audio
            if(this.timeCounter >= 3000 ){
                this.timeCounter = 0;
                return false;
            }

        },
        playAudio(){

            this.curAudio.volume = 0;
            //console.log(window.calibrationAnswers.data.first/100 ,((this.curCounterTone -1) / 10),window.calibrationAnswers.data.first,this.curCounterTone );
            this.curAudio.pause();
            this.curAudio.volume = 0;
            this.curAudio.currentTime = 0;
            if(this.currTone === 4000 &&  this.curCounterTone === 4){
                if(!this.answered)
                    this.answers.push({
                        'tone':this.currTone,
                        'answer':0
                    });
                this.saveAndNextStep();
                return false;
            }
            if(this.curCounterTone === 4){
                this.loadingTone = true;
                this.nextBtn = true;

                if(!this.answered)
                  this.answers.push({
                      'tone':this.currTone,
                      'answer':0
                  });

                this.answered = false;
                this.currTone *= 2;
                this.curAudio = this.tones[this.currTone];

                this.curCounterTone = 0;
            }
            //let volume = window.calibrationAnswers.data.second/100;
            //volume = volume > 1 ? 1 : volume;

           // console.log(this.curAudio.volume,window.calibrationAnswers.data.first,volume);

            //this.curAudio.volume = volume;
            this.curAudio.play();
            this.curCounterTone++;
        },
        nextTest(){
            this.answered = true;
            this.loadingTone = true;
            // mines 1 because  this.curCounterTone is always plussed 1
            ///console.log("called! nextTest -->  ",this.currTone,this.answers);

            this.answers.push({
                'tone':this.currTone,
                'answer':this.curCounterTone
            });

            this.curCounterTone = 4;

            this.startTest();


        },
        /**
         * all tests done go next STEP
         */
        saveAndNextStep(){

            clearInterval(this.intervals);

            window.PureToneAnswers = this.answers;
            this.$parent.$router.replace('/speech_test');
        }
    }
}
</script>

<style scoped>
  .passed{
    background-color: #00b7c6 !important;
  }
  #PureToneTest{
    margin: 40px 0;
    text-align: center;
    padding: 0 10px 30px;
  }
  #PureToneTest button{
    text-align: center;
    cursor: pointer;
    border: none;
    float: right;
    width: 34%;
    margin: 0 8%;
    padding-top: 12px;
    padding-bottom: 10px;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
  @media (max-width: 599px) {
    #PureToneTest button{
      width: 90%;
    }
  }

  .HearingTest-test--title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 54px;
    line-height: 52px;
    color: #00b7c6;
  }
  .HearingTest-test--text {
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--calibrationContainer {
    display: block;
    padding: 15px 0 0;
    position: relative;
    height: 150px;
    text-align: center;
    width: 100px;
    margin: 0 auto;
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
    float: left;
    width: 100px;
    margin-top: 18px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles {
    width: 100px;
    height: 100px;
    margin-top: 10px;
    position: absolute;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--playButtonContainer {
    position: absolute;
    width: 76px;
    height: 76px;
    margin: 11px 12px 0 0;
    background-color: #b5be00;
    border-radius: 100px;
    cursor: pointer;
    z-index: 5;
    box-shadow: 0px 0px 1px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--playButtonContainer .HearingTest-test--frequency {
    margin-top: 18px;
    font-weight: normal;
    font-style: normal;
    font-size: 32px;
    line-height: 22px;
    color: #fff;
    text-align: center;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--spinnerBubble {
    position: relative;
    background-color: #ffffff;
    border: 1px solid #231f20;
    height: 15px;
    width: 15px;
    border-radius: 15px;
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }
  .HearingTest-test--toneButton {
    text-align: center;
    width: 120px;
    margin: 10px auto 0;
    cursor: pointer;
    background-color: #00b7c6;
    padding-top: 9px;
    padding-bottom: 7px;
    font-weight: normal;
    font-style: normal;
    font-size: 22px;
    line-height: 22px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingPureToneTestSpeaker.vue